import { useEffect, useRef } from 'react'
import { useSelector } from 'react-redux'

import { skipToken } from '@reduxjs/toolkit/query'
import { AxiosError } from 'axios'

import { SUPERVISOR_ROLES } from '../../common/constants/appConstants'
import { hasRole } from '../../common/utils/utils'
import { getAuthConfig, getAuthRoles, getAuthUserId } from '../auth/authSelectors'
import { useCreateWebKeyMutation, useGetWebKeyQuery } from '../authApi'

const useWebKey = () => {
  const userId = useSelector(getAuthUserId)
  const userRoles = useSelector(getAuthRoles)
  const config = useSelector(getAuthConfig)
  const isSupervisor = hasRole(userRoles, SUPERVISOR_ROLES)
  const [createWebKey] = useCreateWebKeyMutation()
  const hasAttemptedCreateWebKeyRef = useRef(false)

  const { data: webKey, error } = useGetWebKeyQuery(userId ? { providerId: userId } : skipToken, {
    skip: isSupervisor || !config?.bcPlatform,
  })

  useEffect(() => {
    const axiosError = error as AxiosError
    if (axiosError?.response?.status === 404 && !hasAttemptedCreateWebKeyRef.current) {
      hasAttemptedCreateWebKeyRef.current = true
      createWebKey({ providerId: userId })
    }
  }, [createWebKey, error, userId])

  return webKey
}

export default useWebKey
